export default __webpack_public_path__ + "static/media/black_diameter.0a52f285.svg";